export const LOGIN_NOT_REQUIRED_PAGES = ['login', 'register', 'reset-password'];

export const LOGIN_REQUIRED_PAGES = ['', 'funds', 'leads', 'alerts', 'contacts', 'my-account', 'client-management'];

export const ADMIN = 'ADMIN';

export const languagesArray = [
  { value: 'en', label: 'HOMEPAGE.NAVBAR.en' },
  { value: 'pt', label: 'HOMEPAGE.NAVBAR.pt' }
  /* { value: 'fr', label: 'HOMEPAGE.NAVBAR.fr' }  */
];
